import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useForm } from 'react-hook-form';
import { FileUploader } from "react-drag-drop-files";
import { ImagePlusIcon } from '../../icons/Solid';

const UploadLogo = ({
    existingCompanyDetails,
    handleLogoUpload,
    nextPage,
    prevPage,
}) => {

    const { org } = existingCompanyDetails;

    const [image, setImage] = useState();
    const [uploadedFile, setUploadedFile] = useState();
    const { handleSubmit } = useForm();

    const handlePhotoUpload = (file) => {
        setUploadedFile(file);
        setImage(URL.createObjectURL(file));
    }

    const onSubmit = () => {
        if (uploadedFile?.name) handleLogoUpload(uploadedFile, org);
        nextPage();
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} style={{textAlign: "-webkit-center"}}>
            <div style={{ display: 'flex', justifyContent: 'center'}}>
            <FileUploader
                handleChange={handlePhotoUpload}
                name="file"
                children={
                    <div className='upload-company-logo' style={{ }}>
                        <ImagePlusIcon style={{ height: '3.5rem' }} />
                        <span>{image ? 'Re-upload' : 'Upload'} or drop a file</span>
                    </div>
                }
                types={["JPG", "PNG", "JPEG"]} />
            </div>
            {image && <img style={{ maxWidth: '150px', marginTop: '10px', borderRadius: '1rem' }} src={image} />}
            <div style={{ marginTop: 10 }}>
                <a href="#" className="btn btn-default left" onClick={prevPage}>Back</a>
                <button className="btn btn-success right" type="submit">
                    Save
                </button>
                {!image &&
                    <button className="btn btn-default right" onClick={nextPage} style={{ marginRight: 10 }}>
                        Skip
                    </button>
                }
                <div className="clearfix" />
            </div>
        </form>
    )
};

const mapStateToProps = (state) => {
    return {
        leaveTypes: state.leave.leaveTypes,
        existingCompanyDetails: state.company.newCompany
    }
};

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(UploadLogo);